import React from 'react';

interface IDeleteIconProps {
	bold?: boolean;
	size?: string;
	fill?: string;
}

export const DeleteIcon = ({ bold = false, size = '24', fill }: IDeleteIconProps) => (
	<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby="trash">
		<title id="trash">trash icon</title>
		<path
			d="M17.25 21H6.75C6.35218 21 5.97064 20.842 5.68934 20.5607C5.40804 20.2794 5.25 19.8978 5.25 19.5V6H18.75V19.5C18.75 19.8978 18.592 20.2794 18.3107 20.5607C18.0294 20.842 17.6478 21 17.25 21Z"
			stroke={fill || '#3D3D3D'}
			strokeLinejoin="round"
			strokeWidth={bold ? 1.5 : 1}
		/>
		<path d="M9.75 16.5V10.5" stroke={fill || '#3D3D3D'} strokeLinejoin="round" strokeWidth={bold ? 1.5 : 1} />
		<path d="M14.25 16.5V10.5" stroke={fill || '#3D3D3D'} strokeLinejoin="round" strokeWidth={bold ? 1.5 : 1} />
		<path d="M2.25 6H21.75" stroke={fill || '#3D3D3D'} strokeLinejoin="round" strokeWidth={bold ? 1.5 : 1} />
		<path
			d="M14.25 3H9.75C9.35218 3 8.97064 3.15804 8.68934 3.43934C8.40804 3.72064 8.25 4.10218 8.25 4.5V6H15.75V4.5C15.75 4.10218 15.592 3.72064 15.3107 3.43934C15.0294 3.15804 14.6478 3 14.25 3Z"
			stroke={fill || '#3D3D3D'}
			strokeLinejoin="round"
			strokeWidth={bold ? 1.5 : 1}
		/>
	</svg>
);
